module.exports = __webpack_public_path__ + "static/media/video.a1857173.webp";